import { useForm, Controller } from "react-hook-form";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import styles from "../RequestPage.module.scss";
import { AssessmentStatus } from "../../../../model/leads/leads";
import StatusRadio from "./status-radio/StatusRadio";

interface ChangeScheduleStatusModalProps {
	onClose: () => void;
	onSubmit: (status: "progress" | "completed") => void;
	currentStatus: AssessmentStatus;
	isLoading?: boolean;
}

interface FormData {
	status: "progress" | "completed";
}

export const ChangeScheduleStatusModal = ({ 
	onClose, 
	onSubmit, 
	currentStatus,
	isLoading = false 
}: Readonly<ChangeScheduleStatusModalProps>) => {
	const {
		control,
		handleSubmit,
		watch,
		formState: { errors, isValid }
	} = useForm<FormData>({
		mode: "onChange",
		defaultValues: {
			status: undefined as any // No default selection
		}
	});

	// Watch the status value to determine if submit should be enabled
	const watchedStatus = watch("status");
	const isFormValid = isValid && watchedStatus && !isLoading;

	const handleFormSubmit = (data: FormData) => {
		onSubmit(data.status);
	};

	return (
		<CommonDialog onCloseDialog={onClose}>
			<div className={`${styles.modal_container} ${styles.assessment_modal}`} style={{ height: 300}}>
				<div className={styles.head}>
					<h4 className={styles.title}>Change Status</h4>
					<svg 
						className={styles.clickable} 
						onClick={onClose} 
						width="18" 
						height="18" 
						viewBox="0 0 18 18" 
						fill="none" 
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15.75 15.75L9 9M9 9L2.25 2.25M9 9L15.75 2.25M9 9L2.25 15.75"
							stroke="black"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>

				<form onSubmit={handleSubmit(handleFormSubmit)}>
					<div className={styles.formSection} style={{marginBottom: 25}}>
						<Controller
							name="status"
							control={control}
							rules={{ 
								required: "Please select a status" 
							}}
							render={({ field }) => (
								<>
									<StatusRadio
										name="status"
										value="progress"
										label="In Progress"
										checked={field.value === "progress"}
										onChange={field.onChange}
										variant="progress"
									/>

									<StatusRadio
										name="status"
										value="completed"
										label="Completed"
										checked={field.value === "completed"}
										onChange={field.onChange}
										variant="completed"
									/>
									
									{errors.status && (
										<div className={styles.error}>
											{errors.status.message}
										</div>
									)}
								</>
							)}
						/>
					</div>

					<button 
						type="submit" 
						className={`${styles.btn} ${styles.btn_primary}`} 
						disabled={!isFormValid}
					>
						{isLoading ? "Updating..." : "Change"}
					</button>
				</form>
			</div>
		</CommonDialog>
	);
};